/**
 * 站点内容页（运维平台「内容管理」）跨组件打开事件：
 * FooterBar / LoginModal 等深层组件通过 CustomEvent 通知 AppNew 切换到 content 视图，
 * 避免层层传 prop（AppNew → HomePage → FooterBar）。模式与 OPEN_MEMBERSHIP_EVENT 一致。
 */
export const OPEN_CONTENT_EVENT = 'bongai:open-content';

export function requestOpenContent(slug: string): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_CONTENT_EVENT, { detail: { slug } }));
  }
}

/** 页脚/协议条链接 → site_contents.slug（与主后端 /api/site-contents/{slug} 对齐） */
export const CONTENT_LINKS = [
  { label: '隐私政策', slug: 'privacy-policy' },
  { label: '用户协议', slug: 'user-agreement' },
  { label: '版权申明', slug: 'copyright' },
  { label: '免责申明', slug: 'disclaimer' },
  { label: '联系我们', slug: 'contact' },
] as const;
